document.addEventListener('DOMContentLoaded', function() {
  const triggers = document.querySelectorAll('.hlf-uo-trigger');
  const overlays = document.querySelectorAll('.hlf-uo-modal-overlay');
  
  if (triggers.length === 0 || overlays.length === 0) return;

  // Since there might be multiple sections, we scope logic to each section
  triggers.forEach(trigger => {
    const id = trigger.id.replace('HlfUoTrigger-', '');
    const modal = document.getElementById(`HlfUoModal-${id}`);
    
    if (!modal) return;
    
    const closeBtn = modal.querySelector('.hlf-uo-modal__close');
    const tcs = modal.querySelectorAll('.hlf-uo-tc');
    const copyBtns = modal.querySelectorAll('.hlf-uo-coupon__copy');

    // Open Modal
    trigger.addEventListener('click', () => {
      modal.classList.add('is-active');
      document.body.style.overflow = 'hidden'; // prevent background scrolling
    });

    // Close Modal Function
    const closeModal = () => {
      modal.classList.remove('is-active');
      document.body.style.overflow = '';
    };

    // Close on button click
    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }

    // Close on overlay click (but not modal content click)
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeModal();
    });

    // T&C Accordion Logic
    tcs.forEach(tc => {
      const tcTrigger = tc.querySelector('.hlf-uo-tc__trigger');
      if (tcTrigger) {
        tcTrigger.addEventListener('click', () => {
          tc.classList.toggle('is-open');
        });
      }
    });

    // Copy Coupon Logic
    copyBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const code = btn.getAttribute('data-code');
        if (!code) return;

        navigator.clipboard.writeText(code).then(() => {
          const originalText = btn.textContent;
          btn.textContent = 'COPIED!';
          btn.classList.add('is-copied');

          setTimeout(() => {
            btn.textContent = originalText;
            btn.classList.remove('is-copied');
          }, 2000);
        }).catch(err => {
          console.error('Failed to copy code: ', err);
        });
      });
    });
  });
});
